import React from 'react'

import Icon from './Icon'

function ProgressBar({
  title,
  percent, 
  label,
  icon,
  middle,
  dashboard
}) {
  
  return (
    <div className={`mc-progressBarDashboard-container ${title ? 'has-title' : ''} ${middle ? 'col-2' : 'col-1'}`}>
      {title &&
        <div className='mc-progressBarDashboard-title'>
          {title}
        </div>
      }
      {dashboard &&
        <span className='mc-progressBarDashboard-label'>{`${percent}%`} {dashboard}</span>
      }
      <div className="mc-progressBarDashboard-progress" style={{"width": `${(percent) > 100 ? (100) : (percent)}%`}}></div>
      <div className={`mc-progressBarDashboard-percent ${percent > 52 ? 'white' : ''}`}>
        {icon &&
          <Icon name={icon} />
        }
        {label && label}
      </div>
    </div>
  )
}

export default ProgressBar